import { CopyToClipboard } from '@components/copy-to-clipboard';
import CheckSharpIcon from '@mui/icons-material/CheckSharp';
import LinkSharpIcon from '@mui/icons-material/LinkSharp';
import { IconButton, Tooltip } from '@mui/material';
import { FunctionComponent } from 'react';

export type CopyLinkButtonProps = {
  text: string;
};

export const CopyLinkButton: FunctionComponent<CopyLinkButtonProps> = (
  props,
) => {
  const { text } = props;

  return (
    <CopyToClipboard
      text={text}
      copyElement={
        <Tooltip title="Copy link">
          <IconButton>
            <LinkSharpIcon />
          </IconButton>
        </Tooltip>
      }
      copiedElement={
        <IconButton>
          <CheckSharpIcon />
        </IconButton>
      }
    />
  );
};
